import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"

import MultiTagRender from "../MultiTagRender"

const IrisCodeTroubleshootPanel = ({ data, contents, links }) => {
    const { t } = useTranslation()

    let contentData
    if(data?.data){
        contentData = data?.data
    }else{
        contentData = data
    }
    return (
        <>
            { contentData?.irisHelpTextTitle && (<div className="w-[100%]">
                <h1 className={ "font-bold text-secondary-50 dark:text-white" }>
                    { contentData?.irisHelpTextTitle }
                </h1>
            </div>) }

            <MultiTagRender contents={ contents } links={ links }/>
            { contentData?.accessoryTextlink && (
                <div className="w-[100%]">
                    <MultiTagRender contents={ contentData?.accessoryTextlink?.accessoryDynamicLink?.json?.content } />
                </div>
            ) }
            { contentData?.useInstructionTextlink && (
                <div className="w-[100%]">
                    { contentData?.useInstructionTextlink?.useInstructionTextTitle } 
                    &nbsp;&nbsp;
                    <a target="_blank" href={ contentData?.useInstructionTextlink?.useInstructionLink } className="text-primary-100 text-sm font-lighter underline dark:text-darkModeBlue" rel="noreferrer">{ t("common.link") }</a>
                </div>
            ) }
        </>
    )
}

IrisCodeTroubleshootPanel.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.shape({
            irisHelpTextTitle: PropTypes.string, // Title for the help text
            accessoryTextlink: PropTypes.shape({
                accessoryDynamicLink: PropTypes.shape({
                    json: PropTypes.shape({
                        content: PropTypes.arrayOf(PropTypes.object) // Content for accessory dynamic link
                    })
                })
            }),
            useInstructionTextlink: PropTypes.shape({
                useInstructionTextTitle: PropTypes.string, // Title for use instruction text
                useInstructionLink: PropTypes.string // Link for use instruction
            }),
            footerText: PropTypes.shape({
                footerTextTitle: PropTypes.string // Title for footer text
            })
        }),
        irisHelpTextTitle: PropTypes.string, // Title for the help text
        accessoryTextlink: PropTypes.shape({
            accessoryDynamicLink: PropTypes.shape({
                json: PropTypes.shape({
                    content: PropTypes.arrayOf(PropTypes.object) // Content for accessory dynamic link
                })
            })
        }),
        useInstructionTextlink: PropTypes.shape({
            useInstructionTextTitle: PropTypes.string, // Title for use instruction text
            useInstructionLink: PropTypes.string // Link for use instruction
        }),
        footerText: PropTypes.shape({
            footerTextTitle: PropTypes.string // Title for footer text
        })
    }), // Data object containing all the content
    contents: PropTypes.arrayOf(PropTypes.object), // Array of content objects for MultiTagRender
    links: PropTypes.arrayOf(PropTypes.object) // Array of link objects for MultiTagRender
}


export default React.memo(IrisCodeTroubleshootPanel)
